/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
	name: '',
	status: false,
	message: null,
	callback: null
}
